export default __webpack_public_path__ + "static/media/Lois_Hollis_AHV_In_Moms_We_Trust.6aca02bd.jpg";